import React from 'react';

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
} from 'recharts';

import {
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';

import { FieldChartData } from '../types';

interface Props {
  data: FieldChartData[];
  period: 'week' | 'month';
}

const COLORS = [
  '#6366F1',
  '#8B5CF6',
  '#06B6D4',
  '#10B981',
  '#F59E0B',
  '#EF4444',
  '#EC4899',
];

const FieldBarChart = ({ data,period}: Props) => {
   // console.log("Field attributes data",data)
  return (
    <Card
      elevation={3}
      style={{
        borderRadius: 16,
        height: '100%',
      }}
    >
      <CardContent>

        <Typography
          variant="h6"
          style={{
            fontWeight: 700,
            marginBottom: 20,
          }}
        >
          Field Distribution
        </Typography>
<Typography
  variant="body2"
  color="textSecondary"
  style={{ marginBottom: 16 }}
>
  {period === 'week'
    ? 'Last 7 Days'
    : 'Last 30 Days'}
</Typography>
        <ResponsiveContainer
          width="100%"
height={Math.max(500, data.length * 45)}        >
          <BarChart
            data={data}
            layout="vertical"
                barCategoryGap="5"
            margin={{
              top: 10,
                bottom: 20,
              left: 40,
              right: 25,
            }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal
              vertical={false}
            />

            <XAxis
              type="number"
              tickFormatter={(value) =>
                Intl.NumberFormat('en', {
                  notation: 'compact',
                }).format(value)
              }
            />

       <YAxis
    type="category"
    dataKey="fieldName"
    width={220}
    tick={{
        fontSize: 12,
        fontWeight: 600,
    }}
    tickFormatter={(value) =>
        value.length > 28
            ? value.substring(0, 28) + "..."
            : value
    }
/>
           <Tooltip
  content={({ active, payload }) => {

    if (!active || !payload?.length) return null;

    const row = payload[0].payload;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: 10,
          padding: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,.15)",
        }}
      >
        <div style={{ fontWeight: 700, marginBottom: 8 }}>
          {row.fieldName}
        </div>

        <div>Total : {row.value.toLocaleString()}</div>
        <div style={{ color: "#22C55E" }}>
          Added : {row.added.toLocaleString()}
        </div>

        <div style={{ color: "#3B82F6" }}>
          Modified : {row.modified.toLocaleString()}
        </div>

        <div style={{ color: "#EF4444" }}>
          Deleted : {row.deleted.toLocaleString()}
        </div>

      </div>
    );
  }}
/>

            <Bar
              dataKey="value"
              radius={[0, 8, 8, 0]}
              barSize={28}
            >
              {data.map((entry, index) => (
                <Cell
                  key={entry.fieldName}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Bar>

          </BarChart>

        </ResponsiveContainer>

      </CardContent>

    </Card>
  );
};

export default FieldBarChart;